import { render, staticRenderFns } from "./observationsInternal.vue?vue&type=template&id=bdbcd47e&"
import script from "./observationsInternal.vue?vue&type=script&lang=js&"
export * from "./observationsInternal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports